import React from 'react';

import { Box, ListItemButton, ListItemText } from 'components';

type Props = {
  isMobile: boolean;
  isCollapsed?: boolean;
  icon?: React.ReactNode;
  title: string;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const NavigationItem: React.FC<Props> = ({
  handleClick,
  isMobile,
  isCollapsed,
  icon,
  title,
}) => {
  return (
    <Box margin={isMobile ? '0rem 0.5rem' : '0rem 1rem 0rem 1rem'}>
      <ListItemButton
        component="button"
        sx={{
          width: '100%',
          padding: isMobile ? '0.5rem 0.75rem' : undefined,
          borderRadius: isMobile ? '8px' : undefined,
        }}
        onClick={handleClick}
      >
        <ListItemText
          primary={
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              }}
            >
              {icon}
              {!isCollapsed && (
                <span style={{ paddingLeft: '1rem' }}>{title}</span>
              )}
            </span>
          }
          primaryTypographyProps={{
            fontSize: isMobile ? '0.9rem' : undefined,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            display: 'block',
          }}
        />
      </ListItemButton>
    </Box>
  );
};
